/**
 * Country flag utilities
 * Mapping lottery names to country codes for flag icons
 */

/**
 * Map of lottery name keywords to country codes
 * Country codes follow ISO 3166-1 alpha-2 standard
 */
export const COUNTRY_MAP = {
  // Thai banks (specific logos)
  gsb: ['ออมสิน', 'gsb'],
  baac: ['ธกส', 'baac', 'ธ.ก.ส'],

  // Asian countries
  kr: ['เกาหลี', 'korea'],
  jp: ['ญี่ปุ่น', 'นิเคอิ', 'japan', 'nikkei'],
  hk: ['ฮ่องกง', 'ฮั่งเส็ง', 'hongkong', 'hong kong', 'hangseng'],
  cn: ['จีน', 'china'],
  tw: ['ไต้หวัน', 'taiwan'],
  sg: ['สิงคโปร์', 'singapore'],
  my: ['มาเลเซีย', 'มาเล', 'malaysia'],
  la: ['ลาว', 'laos'],
  vn: ['เวียดนาม', 'ฮานอย', 'vietnam', 'hanoi'],
  th: ['รัฐบาล', 'ไทย', 'thai'],
  in: ['อินเดีย', 'india'],

  // European countries
  de: ['เยอรมัน', 'germany'],
  gb: ['อังกฤษ', 'uk', 'england'],
  ru: ['รัสเซีย', 'russia'],

  // Middle East & Africa
  eg: ['อียิปต์', 'egypt'],

  // Americas
  us: ['อเมริกา', 'usa', 'ดาวโจนส์', 'dow jones'],
}

/**
 * Get country code from lottery name
 * @param {string} huayName - Lottery name
 * @returns {string|null} - Country code (ISO 3166-1 alpha-2) or null if not found
 */
export function getCountryCode(huayName) {
  if (!huayName || typeof huayName !== 'string') return null

  const name = huayName.toLowerCase().trim()

  // Iterate through country map
  // eslint-disable-next-line no-restricted-syntax
  for (const [countryCode, keywords] of Object.entries(COUNTRY_MAP)) {
    // Check if any keyword matches
    const hasMatch = keywords.some(keyword => name.includes(keyword.toLowerCase()))
    if (hasMatch) return countryCode
  }

  return null
}

/**
 * Get flag icon class name
 * @param {string} huayName - Lottery name
 * @returns {string} - CSS class name for flag icon (e.g., 'flag-icon-kr')
 */
export function getFlagIconClass(huayName) {
  const code = getCountryCode(huayName)
  return code ? `flag-icon-${code}` : ''
}

/**
 * Check if lottery has a flag icon
 * @param {string} huayName - Lottery name
 * @returns {boolean} - True if lottery has a flag icon
 */
export function hasFlag(huayName) {
  return getCountryCode(huayName) !== null
}
